import { ContextMenuButton, Td, Tr } from 'app/components/Table';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { dateFormats } from 'app/constants';
import { MouseEvent } from 'react';
import { ListItemText } from 'app/components/ChakraTableList';
import { PlaylistsListItem } from 'types/playlists.types';
import { usePlayerPlaylist } from 'app/components/AudioPlayer/hooks';
import { ListItemAction } from 'app/components/ChakraTableList/ListItemAction';
import { PlaylistCoverActionButton } from '../PlaylistCoverActionButton';

interface PlaylistRowProps extends ReturnType<typeof usePlayerPlaylist> {
  playlist: PlaylistsListItem;
  href: string;
  contextHandler: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
}

export const PlaylistRow = ({
  playlist,
  isPlayerLoading,
  loadingPlaylistGuid,
  isPlaying,
  loadPlaylist,
  contextHandler,
  href,
}: PlaylistRowProps) => {
  const navigate = useNavigate();

  const loading = isPlayerLoading && loadingPlaylistGuid === playlist.guid;
  const playing = isPlaying && loadingPlaylistGuid === playlist.guid;
  const isPlayable = Boolean(playlist.audioCount);

  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      clickable
      onContextMenu={contextHandler}
      onClick={() => {
        navigate(href);
      }}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        <ListItemAction
          onClick={async () => {
            if (isPlayable) {
              await loadPlaylist({
                playlistGuid: playlist.guid,
                playedLocation: 'PLAYLISTS_LIST',
                images: playlist.images,
              });
            }
          }}
        >
          <PlaylistCoverActionButton
            isAudioPlaying={playing}
            isLoading={loading}
            playable={isPlayable}
            image={
              playlist.images.find((image) => image.name === 'playlist-tiny')
                ?.href
            }
          />
        </ListItemAction>
      </Td>
      <Td sx={{ pl: 0 }}>
        <ListItemText
          primary={playlist.title}
          title={playlist.title}
          data-testid="playlist-title"
          primaryTextProps={{
            color: loadingPlaylistGuid === playlist.guid ? 'P.80' : undefined,
          }}
        />
      </Td>
      <Td>
        <ListItemText
          primary={format(
            new Date(playlist.updated.iso),
            dateFormats.LIST_FORMAT
          )}
          data-testid="playlist-modified"
        />
      </Td>
      <Td>
        <ListItemText
          primary={format(
            new Date(playlist.created.iso),
            dateFormats.LIST_FORMAT
          )}
          data-testid="playlist-created"
        />
      </Td>
      <Td>
        <ListItemText
          primary={`${playlist.audioCount}`}
          data-testid="playlist-files"
        />
      </Td>
      <Td className="gap" />
      <Td>
        <ContextMenuButton onClick={contextHandler} />
      </Td>
    </Tr>
  );
};
